<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.mobile"
    :value="isOpen"
    :max-width="maxWidth"
    @click:outside="$emit('close')"
    :persistent="!!persistent"
  >
    <v-card class="d-flex flex-column">
      <v-toolbar class="flex-grow-0 elevation-0" color="#FFB300" dense dark>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- Body Slot -->
      <slot></slot>

      <!-- Footer Slot -->
      <slot v-if="!hideFooter" name="footer">
        <v-card-actions class="justify-end">
          <v-btn v-if="!hideSecondaryBtn" :elevation="0" @click="$emit('cancel')">{{
            secondaryText
          }}</v-btn>
          <v-btn
            :loading="isSubmitting"
            v-if="!hidePrimaryBtn"
            :elevation="0"
            color="primary"
            @click="$emit('confirm')"
            >{{ primaryText }}</v-btn
          >
        </v-card-actions>
      </slot>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isOpen: Boolean,
    persistent: { Boolean, default: true },
    hideFooter: { Boolean, default: false },
    maxWidth: {
      type: Number,
      default: 548
    },
    title: String,
    hideSecondaryBtn: {
      type: Boolean,
      default: false
    },
    hidePrimaryBtn: {
      type: Boolean,
      default: false
    },
    primaryText: {
      default: 'Confirm',
      type: String
    },
    secondaryText: {
      default: 'Close',
      type: String
    },
    isSubmitting: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.$emit('init')
  }
}
</script>
